import { z } from 'zod';

import { transformTimestampDate } from 'utils/common/transformTimestampDate';
import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const UptimeResponseSchema = z
  .object({
    data: z.object({
      uptime_mode: z.boolean(),
      uptime_change_at: z.string().nullable(),
    }),
  })
  .transform(transformKeysToCamelCase)
  .transform((data) => {
    return {
      ...data,
      data: data.data.uptimeChangeAt
        ? { ...data.data, uptimeChangeAt: transformTimestampDate(data.data.uptimeChangeAt) }
        : data.data,
    };
  });

export type TUptimeResponse = z.infer<typeof UptimeResponseSchema>;
export type TUptimeData = z.infer<typeof UptimeResponseSchema>['data'];
